import * as yup from 'yup';
import { LayoutItem } from 'models/InputLayoutItem';

export const createYupSchema = (fields: LayoutItem[]) => {
	const newSchema = fields.reduce((schema, field) => {
		const isObject = field.name.indexOf('.') >= 0;

		if (!field.validation) {
			return schema;
		}

		if (!isObject) {
			return { ...schema, [field.name]: field.validation };
		}

		const reversePath = field.name.split('.').reverse();
		const currNestedObject = reversePath.slice(1).reduce(
			(yupObj, path) => {
				return { [path]: yup.object().shape(yupObj) };
			},
			{ [reversePath[0]]: field.validation }
		);

		return { ...schema, ...currNestedObject };
	}, {});

	return yup.object().shape(newSchema);
};
